









































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  addDays,
  differenceInDays,
  format,
  isSameDay,
  isSunday,
  parse
} from "date-fns";
import ServiceScheduleDate from "../components/ServiceScheduleDate.vue";
import AppHeader from "../../../views/AppHeader.vue";
import VIconPrint from "../../../components/icons/VIconPrint.vue";
import VSearchBar from "../../../components/VSearchBar.vue";
import SearchScheduleBar, {
  SearchScheduleBarFormData
} from "../components/SearchScheduleBar.vue";
import ServiceTaskCell, {
  Props as ServiceTaskCellProps
} from "../components/ServiceTaskCell.vue";
import {
  getServiceTasks,
  GetServiceTasksResponse,
  ServiceTask
} from "@/servicetask/api/service-tasks-api";
import locale from "date-fns/locale/ja";

import draggable from "vuedraggable";
import StartProjectModal from "./StartProjectModal.vue";
import VToolbar from "@/components/V-Toolbar.vue";
import EditServiceTaskModal from "./EditServiceTaskModal.vue";
import assert from "assert";
import VServiceTaskTableCell from "../components/VServiceTaskTableCell.vue";
import VServiceTaskTable from "../components/VServiceTaskTable.vue";
import VServiceTaskTableRowHeader from "../components/VServiceTaskTableRowHeader.vue";

import "@/fonts/IPA-Gothic-normal";
import jsPDF from "jspdf";
import VDatePeriod from "../../../components/VDatePeriod.vue";
import VPrintButton from "../../../components/VPrintButton.vue";
import PrintServiceSchedule, {
  Props as PrintScheduleProps
} from "../components/PrintServiceSchedule.vue";
import { updateTaskDate } from "@/api/task-api";
import { countProjects } from "@/api/project-count-api";
import ProjectsCount from "../../../components/ProjectsCount.vue";
import SearchTaskModal from "./SearchTaskModal.vue";
import parseDate from "@/helpers/parseDate";
import { cloneDeep } from "lodash";
import { ProjectStatus } from "@/models/project-status";
import { Location } from "vue-router";
import DateHoliday from "date-holidays";
import UserServiceApi, {
  UserServiceGateway
} from "@/api/gateways/user-service-api";
import ZoomableContainer from "@/common/ui/components/ZoomableContainer.vue";

/**
 * 指定したidを工程リストの上位に持ってくる
 */
function sortedTasks(tasks: ServiceTask[], taskId: number) {
  const draft = ([] as ServiceTask[]).concat(tasks);
  draft.sort(a => (a.id === taskId ? -1 : 0));
  return draft;
}

@Component({
  components: {
    SearchTaskModal,
    ProjectsCount,
    PrintServiceSchedule,
    VPrintButton,
    VDatePeriod,
    VServiceTaskTable,
    VServiceTaskTableCell,
    VServiceTaskTableRowHeader,
    VToolbar,
    StartProjectModal,
    EditServiceTaskModal,
    VSearchBar,
    SearchScheduleBar,
    ServiceScheduleDate,
    ServiceTaskCell,
    AppHeader,
    VIconPrint,
    draggable,
    ZoomableContainer
  }
})
export default class ServiceSchedulePage extends Vue {
  @Prop({ required: true }) serviceTaskTypeId!: string;
  // 表示確認用。?mode="view"を渡すと編集者でも閲覧モードにする
  @Prop({ default: "edit" }) defaultViewMode!: string;

  // TODO: 表示用の型にする
  schedule: GetServiceTasksResponse | null = null;

  futureProjectsCount = 0; // 未着工の現場件数
  pendingProjectsCount = 0; // 保留の現場件数

  date = new Date();
  seletedDate: string = this.onMobile ? format(this.date, "yyyy-MM-dd") : "";

  startProjectId: number | null = null;
  editTaskId: number | null = null;
  projectModalDefaultTaskStatus = "";
  projectModalDefaultKeyword = "";

  searchTaskModalOpen = false;
  searchTaskSpecialKeyword = "";

  activeTaskId: number | null = null;

  holiday = new DateHoliday("JP");

  taskTypeOptions: { text: string; value: string }[] = [];

  showSearchBar = false;

  private toggleTimeout: number | null = null;

  originalSchedule: GetServiceTasksResponse | null = null;

  toggleSearchBar() {
    if (this.toggleTimeout) {
      clearTimeout(this.toggleTimeout);
    }

    this.toggleTimeout = window.setTimeout(() => {
      this.showSearchBar = !this.showSearchBar;
      if (navigator.vibrate) {
        navigator.vibrate(30);
      }
      if (this.showSearchBar) {
        this.$nextTick(() => {
          const searchContainer = document.querySelector(".search-container");
          if (searchContainer) {
            searchContainer.scrollIntoView({
              behavior: "smooth",
              block: "nearest"
            });
          }
        });
      }
    }, 50);
  }

  private get serviceApi(): UserServiceGateway {
    return new UserServiceApi(this.$store.getters.api);
  }

  get service() {
    return this.$store.state.service;
  }

  get currentUser() {
    return this.$store.state.user;
  }

  get canViewAllUninvitedProjects() {
    return (
      !this.currentUser.hasRole && this.currentUser.canViewAllUninvitedProjects
    );
  }

  get user() {
    return this.$store.getters.user;
  }

  get onMobile() {
    return this.$store.getters.onMobile;
  }

  get editable(): boolean {
    return (
      this.defaultViewMode === "edit" &&
      this.user.can("service/service-tasks/write")
    );
  }

  get projectLinksVisible(): boolean {
    return Boolean(
      (this.editable || (this.schedule && this.schedule.projectLinksVisible)) &&
        this.user.hasRole
    );
  }

  get lastUpdateUser(): string {
    return (
      (this.schedule && this.schedule.staff && this.schedule.staff.name) || ""
    );
  }

  get lastUpdateDate(): string {
    if (this.schedule && this.schedule.updateDate) {
      return format(new Date(this.schedule.updateDate), "yyyy/M/d aK:mm");
    }
    return "";
  }

  get printScheduleProps(): PrintScheduleProps | null {
    if (!this.schedule) {
      return null;
    }
    return {
      schedule: {
        name: this.schedule.name,
        date: this.date,
        days: this.schedule.days.map(day => ({
          date: this.rowLabel(day.date),
          rawDate: day.date,
          items: day.tasks.map(
            (task): ServiceTaskCellProps => ({
              date: day.date,
              task: {
                ...task,
                constructionTasks: task.constructionTasks.map(t => ({
                  id: t.id,
                  shortName: t.shortName,
                  done: t.status === "done"
                }))
              }
            })
          )
        }))
      }
    };
  }

  get defaultQuery(): SearchScheduleBarFormData {
    let operator = "";
    if (
      !this.currentUser.hasRole &&
      this.canViewAllUninvitedProjects &&
      this.$route.query["operator"] == undefined
    ) {
      operator = this.currentUser.staffId;
    }

    return {
      client: String(this.$route.query["client"] || ""),
      operator: String(this.$route.query["operator"] || operator),
      constructionTask: String(this.$route.query["constructionTask"] || ""),
      mobile: String(this.$route.query["mobile"] || ""),
      selectedWeekDisplay: String(this.$route.query["selectedWeekDisplay"] || 1)
    };
  }

  mounted() {
    //@ts-ignore
    if (window.FlutterChannel) {
      // send an event that notify that the page has been  mounted
      //@ts-ignore
      window.FlutterChannel.postMessage(
        JSON.stringify({ event: "PAGE_MOUNTED", data: null })
      );
    }
  }

  public created() {
    this.initServiceSchedule();
    this.initProjectsCount();
  }

  async initServiceSchedule() {
    this.getServiceSchedule().then(schedule => {
      this.schedule = schedule;
    });
  }

  private async getServiceSchedule() {
    let staffId = undefined;
    if (
      !this.currentUser.hasRole &&
      this.canViewAllUninvitedProjects &&
      this.$route.query["operator"] == undefined
    ) {
      staffId = this.currentUser.staffId;
    }
    // TODO: エラーを拾う
    return await getServiceTasks({
      serviceTaskTypeId: Number(this.serviceTaskTypeId),
      date: format(this.date, "yyyy-MM-dd"),
      staffId: this.$route.query.operator
        ? Number(this.$route.query.operator)
        : staffId,
      officeId: this.$route.query.client
        ? Number(this.$route.query.client)
        : undefined,
      constructionTaskId: this.$route.query.constructionTask
        ? Number(this.$route.query.constructionTask)
        : undefined,
      selectedWeekDisplay: this.$route.query.selectedWeekDisplay
        ? Number(this.$route.query.selectedWeekDisplay)
        : undefined
    });
  }

  @Watch("$route")
  onRouteUpdate() {
    this.initServiceSchedule();
  }

  canMoveTask(e: any): boolean {
    if (!e.draggedContext.element.canEdit) {
      return false;
    }
    if (!this.editable && this.currentUser.hasRole) {
      // 編集権限がないとキャンセルする
      return false;
    }
    if (e.from.dataset["date"] === e.to.dataset["date"]) {
      // 移動元と移動先の日付が同じならキャンセルする
      return false;
    }
    if (e.from.dataset["date"] !== e.draggedContext.element.startDate) {
      // 工程の1日目以外はキャンセルする
      return false;
    }

    this.originalSchedule = JSON.parse(JSON.stringify(this.schedule));
    return true;
  }

  async moveTask(e: any) {
    if (!this.schedule) {
      throw new Error("工程表が読み込まれていません。");
    }

    const from: string = e.from.dataset["date"];
    const to: string = e.to.dataset["date"];

    const day = this.schedule.days.find(d => d.date === to);
    if (!day) {
      throw new Error("移動先の日付が見つかりません。");
    }

    const task = day.tasks[e.newIndex];
    if (!task) {
      throw new Error("対象の工程が見つかりません。");
    }

    // 施工日と終了日を書き換えて保存する
    const baseDate = parse(from, "yyyy-MM-dd", new Date());
    const newDate = parse(to, "yyyy-MM-dd", new Date());
    const moveDays = differenceInDays(newDate, baseDate);

    let newTask: any = {
      id: task.id,
      startDate: format(
        addDays(parse(task.startDate, "yyyy-MM-dd", new Date()), moveDays),
        "yyyy-MM-dd"
      ),
      endDate: format(
        addDays(parse(task.endDate, "yyyy-MM-dd", new Date()), moveDays),
        "yyyy-MM-dd"
      ),
      moveTogether: moveDays > 0 && confirm("後ろの工程も一緒に移動しますか？")
    };

    if (
      this.$store.state.service.scheduleNotification &&
      confirm("この工程変更をチャットへ通知します。よろしいですか？")
    ) {
      newTask = {
        ...newTask,
        notify: true
      };
    }

    await updateTaskDate(newTask);
    await this.initServiceSchedule();
  }

  /**
   * 各列の最大数
   */
  get maxRows(): number {
    if (!this.schedule) {
      return 0;
    }

    const actualMaxRows = this.schedule.days.reduce((max, day) => {
      return Math.max(max, day.tasks.length);
    }, 0);

    if (this.onMobile) {
      return actualMaxRows < 12 ? 12 : actualMaxRows;
    }

    return actualMaxRows;
  }

  get maxDays(): number {
    if (!this.schedule) {
      return 0;
    }
    return this.schedule.days.length;
  }

  /**
   * 表示範囲の終端
   */
  get endDate(): Date {
    return addDays(this.date, 6);
  }

  get sortedSchedule(): GetServiceTasksResponse | null {
    if (!this.schedule) return null;

    const taskId = this.activeTaskId;
    if (!taskId) return this.schedule;

    return {
      ...this.schedule,
      days: this.schedule.days.map(day => ({
        ...day,
        tasks: sortedTasks(day.tasks, taskId)
      }))
    };
  }

  get firstTask() {
    if (!this.schedule) {
      throw new Error("工程表が読み込まれていません。");
    }
    let _day = this.schedule.days[0];
    if (!_day) {
      return null;
    }
    return _day.tasks;
  }
  /**
   * 指定した日数移動する
   */
  moveDate(days: number) {
    const newDate = addDays(this.date, days);
    if (isSunday(newDate)) {
      // 日曜日になる場合、さらに1日とばす
      this.changeDate(addDays(newDate, days > 0 ? 1 : -1));
    } else {
      this.changeDate(newDate);
    }
  }

  /**
   * 特定の日付に移動する
   */
  changeDate(date: Date) {
    if (isSameDay(this.date, date)) {
      return;
    }
    this.date = date;
    this.initServiceSchedule();
  }

  /**
   * 現場を検索する
   * @param keyword
   */
  openSearchTaskModal(keyword: string) {
    if (!keyword) {
      return;
    }
    this.searchTaskSpecialKeyword = keyword;
    this.searchTaskModalOpen = true;
  }

  /**
   * 工程を検索する
   */
  search(query: SearchScheduleBarFormData) {
    this.$router.push({
      query: {
        client: query.client,
        operator: query.operator,
        constructionTask: query.constructionTask,
        mobile: query.mobile,
        selectedWeekDisplay: query.selectedWeekDisplay
      }
    });
  }

  /**
   * 工程を編集する
   */
  editTask(task: any) {
    assert(task.id, "task id is required");
    this.editTaskId = task.id;
  }

  cellProps(
    task: ServiceTask,
    date: string,
    index: number
  ): ServiceTaskCellProps {
    return {
      task: Object.assign(cloneDeep(task), {
        constructionTasks: task.constructionTasks.map(t => ({
          id: t.id,
          shortName: t.shortName,
          done: t.status === "done"
        }))
      }),
      date,
      editable: this.editable || task.canEdit,
      idAttr: `${date}-${index}`
    };
  }

  startProject(projectId: number) {
    this.startProjectId = projectId;
  }

  rowLabel(date: string) {
    return format(parse(date, "yyyy-MM-dd", new Date()), "M/d(E)", { locale });
  }

  print() {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "px",
      format: "a3"
    });
    const component = this.$refs["printElement"] as Vue;
    if (!component) {
      throw new Error("Print Error");
    }
    const el = component.$el as HTMLElement;
    if (!el) {
      throw new Error("Print Error");
    }
    doc.html(el, {
      width: 892,
      windowWidth: el.clientWidth,
      callback: doc => {
        doc.save();
      }
    });
  }

  private initProjectsCount() {
    countProjects({ status: "未着工" }).then(data => {
      this.futureProjectsCount = data.projectsCount;
    });
    countProjects({ status: "保留" }).then(data => {
      this.pendingProjectsCount = data.projectsCount;
    });
  }

  selectTask(task: { id: number; date: string }) {
    this.activeTaskId = task.id;
    this.changeDate(parseDate(task.date));

    this.searchTaskModalOpen = false;
  }

  toProjectList(status: ProjectStatus): Location {
    return {
      name: "project-list",
      query: { status }
    };
  }
  isHoliday(date: string): boolean {
    const copyHoliday = cloneDeep(this.holiday);
    const day = copyHoliday.isHoliday(new Date(date));

    return Array.isArray(day) && day.length > 0;
  }
  isWeekend(date: string): boolean {
    // Get the day of the week (0 for Sunday, 6 for Saturday)
    const day = new Date(date).getDay();
    return day === 0 || day === 6;
  }
  highlightDateClass(date: string): string {
    if (this.isHoliday(date)) {
      return "holiday";
    }
    if (this.isWeekend(date)) {
      return "weekend";
    }
    return "";
  }

  handleClick() {
    if (this.onMobile) {
      (this.$refs.scheduleDateInput as any).focus(); // for IOS
      ((this.$refs.scheduleDateInput as Vue).$el as any).showPicker(); // for android
    } else {
      ((this.$refs.scheduleDateInput as Vue).$el as any).showPicker();
    }
  }

  @Watch("seletedDate")
  onDateChanged(newValue: string) {
    this.date = new Date(newValue);
    this.initServiceSchedule();
  }
}
